export const withHex = (value: string, fallback = '#000000') => {
  const match = value.match(/\d+/g);

  return (
    '#' +
    (match && match.length >= 3
      ? match
          .slice(0, 3)
          .map((colorChanel) => (+colorChanel).toString(16).padStart(2, '0'))
          .join('')
      : fallback.replace('#', '')
    ).toUpperCase()
  );
};

/*
  Difference between
  https://zeroheight.com/7sjjzhgo2/p/11a5e7-color-palette-wiring and
  https://github.com/wix-private/tpa-settings/blob/master/packages/tpa-settings/src/getWixColor.ts
 */
const colorReference: Record<string, string> = {
  'links-and-actions-color': 'color-action',

  'color-heading-1': 'color-title',
  'heading-1-color': 'color-title',

  'color-heading-2': 'color-title',
  'heading-2-color': 'color-title',

  'color-heading-3': 'color-title',
  'heading-3-color': 'color-title',

  'color-paragraph-2': 'color-text-primary',
  'paragraph-2-color': 'color-text-primary',

  'shade-3-color': 'color-fill-base-shade-3',
  'primary-background-color': 'color-fill-background-primary',

  'button-border-left-color-primary': 'color-8',
  'button-border-right-color-primary': 'color-8',
  'button-border-top-color-primary': 'color-8',
  'button-border-bottom-color-primary': 'color-8',
  'button-icon-color-primary': 'color-1',

  'button-border-left-color-primary-hover': 'color-8',
  'button-border-right-color-primary-hover': 'color-8',
  'button-border-top-color-primary-hover': 'color-8',
  'button-border-bottom-color-primary-hover': 'color-8',
  'button-icon-color-primary-hover': 'color-1',

  'button-icon-color-primary-disabled': 'color-1',
  'button-primary-color': 'button-color-text-primary',
  'button-primary-background-color': 'button-color-fill-primary',
};

/**
 * Maps a WDS-style token name to the TPA palette key used by `tpa-settings` defaults.
 * Accepts values like `--wst-…`, `wst-…`, or bare keys; strips `--` / `wst-`, then looks up
 * the `colorReference` map below; if there is no mapping, returns the normalized key unchanged.
 * @see https://zeroheight.com/7sjjzhgo2/p/11a5e7-color-palette-wiring
 */
export const tpaColorName = (wstColorName: string): string => {
  const key = wstColorName
    .replace(/^--+/, '') // remove any number of leading --
    .replace(/^wst-/, ''); // remove wst- if present

  return colorReference[key] ?? key;
};
